var map = {
	"./brands.fa.svg": [
		617,
		5
	],
	"./duotone.fa.svg": [
		618,
		6
	],
	"./light.fa.svg": [
		619,
		7
	],
	"./regular.fa.svg": [
		620,
		8
	],
	"./solid.fa.svg": [
		621,
		9
	],
	"./thin.fa.svg": [
		622,
		10
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 348;
module.exports = webpackAsyncContext;